module.exports = __webpack_public_path__ + "img/9f7a338.jpg";